/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Materialclosetowner2Inputs */

const de__field_materialclosetowner2 = /** @type {(inputs: _Field_Materialclosetowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Materialschrankschlüssel-Besitzer:in`)
};

/**

* @param {_Field_Materialclosetowner2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_materialclosetowner2 = /** @type {((inputs?: _Field_Materialclosetowner2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Materialclosetowner2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_materialclosetowner2(inputs)
});
export { _field_materialclosetowner2 as "_field_materialClosetOwner" }